export const VENDOR_PAYMENT_TYPE = {
  GENERAL_CONTRACTOR: "GENERAL_CONTRACTOR",
  SOFT_COSTS_DIRECT_PAY: "SOFT_COSTS_DIRECT_PAY",
  SUBCONTRACTOR_DIRECT_PAY: "SUBCONTRACTOR_DIRECT_PAY",
  SUBCONTRACTOR_DIRECT_PAY_SEND_TO_GC: "SUBCONTRACTOR_DIRECT_PAY_SEND_TO_GC",
  SUBCONTRACTOR_REIMBURSABLE: "SUBCONTRACTOR_REIMBURSABLE",
};
